<template>
	<AppContent class="loading" />
</template>
<script>

import {
	AppContent,
} from '@nextcloud/vue'

export default {
	name: 'Loading',

	components: {
		AppContent,
	},
}

</script>
